export enum ViewHeaderActionTypes {
  UpdateDesktopHeader = 'UpdateDesktopHeader',
  UpdateMobileHeader = 'UpdateMobileHeader',
  CloseAll = 'CloseAll',
}
